import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MapCenter = ({ center }) => {
    const map = useMap();

    const normalizeCenter = (value) => {
        if (Array.isArray(value) && value.length === 2) {
            return value;
        }

        if (value && typeof value === "object" && value.lat != null && value.lng != null) {
            return [Number(value.lat), Number(value.lng)];
        }

        return null;
    };

    useEffect(() => {
        const normalizedCenter = normalizeCenter(center);
        if (normalizedCenter) {
            map.setView(normalizedCenter, map.getZoom());
        }
    }, [center, map]);
    return null;
};

export default MapCenter;
